export const LOCALE_KEYS = ["date_picker.label_now"];

export const BLUR_DELAY_MS = 10;
